import {downloadSvg as Icon__small__downloadSvg} from '../Icon__small/Icon__small--download.js'

export var download = {
  name: 'download',
  category: 'icon',
  colorable: true,
  svg: Icon__small__downloadSvg,
};
